module.exports = __webpack_public_path__ + "img/ics_o_urgent_delivery.53d27616.svg";